import { render, staticRenderFns } from "./calculator.vue?vue&type=template&id=4a5fb50e&scoped=true&"
import script from "./calculator.vue?vue&type=script&lang=js&"
export * from "./calculator.vue?vue&type=script&lang=js&"
import style0 from "./calculator.vue?vue&type=style&index=0&id=4a5fb50e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a5fb50e",
  null
  
)

export default component.exports